import React from 'react';
import { CloseRounded } from '@material-ui/icons';

const Close = ({ color = 'currentColor', padding = '4px', className = '' }) => {
    return <div style={{ color, borderRadius: '50%', display: 'inline-flex' }} className={className}>
        <CloseRounded style={{ padding }} />
    </div>
}

export default Close;